import React, { useState } from 'react';
import { SlArrowDown } from 'react-icons/sl';
import { useTranslation } from 'react-i18next';
import BottomModal from '../../../components/modal/bottomModal';
import { useBackPress } from '../../../hooks/useBackPress';
import TipsWaiterSelection from './tipsWaiterSelection';
import TipsWaiterTeamPhoto from './tipsWaiterTeamPhoto';

const TipsWaiterDropdown = ({
  employees,
  allowWaiterSelect,
  preventSelectAllTeam,
  fromTipsCheckout,
  onSelect,
  tipsAmount,
}) => {
  const { t } = useTranslation();

  const [employeeSelectOpen, setEmployeeSelectOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const { handleBackOnModalOpen, handleBackOnModalClose } = useBackPress(
    fromTipsCheckout ? '/checkout-tips' : '/checkout',
    () => {
      setEmployeeSelectOpen(false);
    },
  );

  if (!allowWaiterSelect || !employees || employees.length === 0) {
    return (
      <>
        <p className="font-primaryMedium text-primary text-base">{t('checkout.addTipTitle')}</p>
        <p className="font-primaryMedium text-bland text-sm mt-1">{t('checkout.addTipSubtitle')}</p>
      </>
    );
  }

  const closeEmployeeSelection = () => {
    setEmployeeSelectOpen(false);
    handleBackOnModalClose();
  };

  const renderWaiterImage = () => {
    const employee = selectedEmployee ? employees.find((x) => x.id === selectedEmployee) : null;
    if (!employee) {
      if (preventSelectAllTeam) {
        return null;
      }

      return (
        <div className="pr-2 mb-2">
          <TipsWaiterTeamPhoto employees={employees} small />
        </div>
      );
    }

    if (!employee.image) {
      return null;
    }

    return (
      <div className="pr-4 mb-2">
        <div
          className={`rounded-full w-[3.2rem] h-[3.2rem]
            overflow-hidden border bg-white border-white top-[2px] relative`}
        >
          <img src={employee.image} alt="" className="rounded-full w-full h-full" />
        </div>
      </div>
    );
  };

  const renderWaiterName = () => {
    const employee = selectedEmployee ? employees.find((x) => x.id === selectedEmployee) : null;

    if (employee) {
      return employee.firstName;
    }

    if (preventSelectAllTeam) {
      return t('checkout.chooseYourWaiter');
    }

    return t('checkout.yourRestaurantTeam');
  };

  return (
    <>
      <p className="font-primaryMedium text-primary text-base">{t('checkout.yourWaiter')}</p>
      <div
        role="button"
        onClick={() => {
          setEmployeeSelectOpen(true);
          handleBackOnModalOpen();
        }}
        className={`bg-lightGrayBg rounded-lg py-4 px-4 mt-2 mb-2 max-w-lg flex flex-row justify-between items-center border border-lightGrayBg ${
          preventSelectAllTeam && !selectedEmployee && tipsAmount > 0
            ? 'border-primaryOrange border'
            : ''
        }`}
      >
        <div className="flex flex-row -mb-2 pr-2 items-center">
          {renderWaiterImage()}
          <div className="mb-2">
            <p className="font-primaryMedium text-primary text-base">{renderWaiterName()}</p>
            <p className="font-primaryMedium text-bland text-sm mt-1">
              {t('checkout.tapToChooseWaiter')}
            </p>
          </div>
        </div>
        <div>
          <SlArrowDown className="text-primary text-xl" />
        </div>
      </div>
      <p className="font-primaryMedium text-bland text-sm mt-1">{t('checkout.addTipSubtitle')}</p>

      <BottomModal
        title={t('checkout.chooseYourWaiter')}
        content={
          <TipsWaiterSelection
            employees={employees}
            selectedEmployee={selectedEmployee}
            onSelectEmployee={(employee) => {
              setSelectedEmployee(employee.id);
              onSelect(employee.id);
              closeEmployeeSelection();
            }}
            onSelectTeam={() => {
              setSelectedEmployee(null);
              onSelect(null);
              closeEmployeeSelection();
            }}
            preventSelectAllTeam={preventSelectAllTeam}
          />
        }
        onClose={() => {
          closeEmployeeSelection();
        }}
        onOutClick={() => {
          closeEmployeeSelection();
        }}
        open={employeeSelectOpen}
      />
    </>
  );
};

export default TipsWaiterDropdown;
